import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";
import { getStoredValue } from "../_helpers/storagehelper";

const initialPhotosData = {};
const photosSearch = {
  isPageRefresh: true,
  facilityID: 0,
  inmateResidentId: "",
  publicFirstName: "",
  publicLastName: "",
  inmateFirstName: "",
  inmateLastName: "",
  photoSubject: "",
  photoSendStartDate: getPastDate(1),
  photoSendEndDate: getCurrentDate(),
  photoActionStatus: 3,
  managementUserID: getStoredValue("user")?.ManagementUserID,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "",
  exportExcel: false,
  exportPDF: false,
};

const multiphotosSearch = {
  isPageRefresh: true,
  facilityID: 0,
  inmateResidentId: "",
  publicFirstName: "",
  publicLastName: "",
  inmateFirstName: "",
  inmateLastName: "",
  photoSubject: "",
  photoSendStartDate: getPastDate(1),
  photoSendEndDate: getCurrentDate(),
  photoActionStatus: 3,
  managementUserID: getStoredValue("user")?.ManagementUserID,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "",
  exportExcel: false,
  exportPDF: false,
}

// create slice
const name = "photos";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const photoAction = { ...slice.actions, ...extraActions };
export const photoReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    facilityData: initialPhotosData,
    photosSearchData: photosSearch,
    multiphotosSearchData: multiphotosSearch,
    photosList: {},
    LoadReviewALLPhotosListData: {},
    photosListFullData: {},
    photoInfo: {},
    updateStatusResponse: {},
    photoReviewList: [],
    multiplePhotoStateList: [],
    photosSearch
  };
}

function createReducers() {
  return {
    resetForm,
    setPhotoInformation,
    setPhotosSearch,
    resetPhotoState,
    updateMultiPhotoData,
    resetmultiPhotoState,
    setmultiPhotosSearch,
    setphotosList,
    setmultiplePhotoStateList
  };

  function setmultiplePhotoStateList(state, action) {
    state.multiplePhotoStateList = action.payload && action.payload;
  }

  function resetForm(state) {
    state.updateStatusResponse = {};
  }

  function resetPhotoState(state) {
    state.photosSearchData = { ...photosSearch };
  }

  function resetmultiPhotoState(state) {
    state.multiphotosSearchData = { ...photosSearch };
  }


  function setPhotoInformation(state, action) {
    state.photoInfo = action.payload && action.payload;
  }

  function setPhotosSearch(state, action) {
    state.photosSearchData = action.payload && action.payload;
  }

  function setmultiPhotosSearch(state, action) {
    state.multiphotosSearchData = action.payload && action.payload;
  }

  function updateMultiPhotoData(state, action) {
    state.LoadReviewALLPhotosListNewData = action.payload && action.payload;
  }

  function setphotosList(state, action) {
    state.photosList = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    getPhotosList: getPhotosList(),
    getPhotosListDownload: getPhotosListDownload(),
    LoadReviewALLPhotosList: LoadReviewALLPhotosList(),
    LoadReviewALLPhotosListNew: LoadReviewALLPhotosListNew(),
    getPhotosInfo: getPhotosInfo(),
    updateStatus: updateStatus(),
    updateStatusPhotosReject: updateStatusPhotosReject(),
    updateStatusNew: updateStatusNew(),
    photoReview: photoReview(),
  };

  function getPhotosList() {
    return createAsyncThunk(`${name}/getPhotosList`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/Photos/LoadPhotosList`, data);
    });
  }

  function getPhotosListDownload() {
    return createAsyncThunk(`${name}/LoadS3PhotosDetailsListDownload`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/Photos/LoadS3PhotosDetailsListDownload`, data);
    });
  }

  function LoadReviewALLPhotosList() {
    return createAsyncThunk(`${name}/LoadReviewALLPhotosList`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Photos/LoadReviewALLPhotosList`,
        data
      );
    });
  }

  function LoadReviewALLPhotosListNew() {
    return createAsyncThunk(
      `${name}/LoadReviewALLPhotosListNew`,
      async (data) => {
        return await fetchWrapper.post(
          `${baseUrl}/Photos/LoadS3PhotosReviewAllListNew`,
          data
        );
      }
    );
  }

  function getPhotosInfo() {
    return createAsyncThunk(`${name}/getPhotosInfo`, async (id) => {
      return await fetchWrapper.get(
        `${baseUrl}/Photos/GetPhotosFroms3New?PhotoCommID=${id}`
      );
    });
  }

  function updateStatusPhotosReject() {
    return createAsyncThunk(`${name}/updateStatusPhotosReject`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Photos/PhotosReject`,
        data
      );
    });
  }

  function updateStatus() {
    return createAsyncThunk(`${name}/updateStatus`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Photos/PhotosApproveOrReject`,
        data
      );
    });
  }

  function updateStatusNew() {
    return createAsyncThunk(`${name}/updateStatusNew`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Photos/PhotosApproveOrRejectNew`,
        data
      );
    });
  }

  function photoReview() {
    return createAsyncThunk(`${name}/photoReview`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Photos/GetApproveRejectPhoto`,
        data
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    //photos list
    .addCase(extraActions.getPhotosList.pending, (state, action) => {
      const params = action.meta.arg;
      // Signal_R purpose
      if (!params?.isNoLoading) {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(extraActions.getPhotosList.fulfilled, (state, action) => {
      state.loading = false;
      const params = action.meta.arg;
      // if (!params?.isReviewPhotos) {
      //   state.photosList = action?.payload;
      // }
      if (params?.exportExcel) {
        state.photosListFullData = action?.payload;
      } else {
        state.photosList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.getPhotosList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get photo list";
    })
    // .addCase(extraActions.getPhotosListDownload.pending, (state, action) => {
    //   const params = action.meta.arg;
    //   // Signal_R purpose
    //   if (!params?.isNoLoading) {
    //     state.loading = true;
    //   }
    //   state.error = null;
    // })
    // .addCase(extraActions.getPhotosListDownload.fulfilled, (state, action) => {
    //   state.loading = false;
    //   const params = action.meta.arg;
    //   if (params?.exportExcel) {
    //     state.photosListFullData = action?.payload;
    //   } else {
    //     state.photosList = action.payload;
    //   }
    //   state.error = null;
    // })
    // .addCase(extraActions.getPhotosListDownload.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Failed to get photo list";
    // })
    //photos info
    .addCase(extraActions.getPhotosInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getPhotosInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.photoInfo = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.getPhotosInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get photo list";
    })

    //LoadReviewALLPhotosList
    .addCase(extraActions.LoadReviewALLPhotosList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadReviewALLPhotosList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadReviewALLPhotosListData = action?.payload;
        state.error = null;
      }
    )
    .addCase(extraActions.LoadReviewALLPhotosList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get photo review list";
    })

    //LoadReviewALLPhotosListNew
    .addCase(extraActions.LoadReviewALLPhotosListNew.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadReviewALLPhotosListNew.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadReviewALLPhotosListNewData = action?.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadReviewALLPhotosListNew.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to get photo review list";
      }
    )

    //update status
    .addCase(extraActions.updateStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updateStatusResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.updateStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get photo list";
    })

    //update status new
    .addCase(extraActions.updateStatusNew.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateStatusNew.fulfilled, (state, action) => {
      state.loading = false;
      state.updateStatusResponseNew = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.updateStatusNew.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get photo list";
    })
    //photo review
    .addCase(extraActions.photoReview.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.photoReview.fulfilled, (state, action) => {
      state.loading = false;
      state.photoReviewList = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.photoReview.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get Review photo list";
    });
}
